import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { SKU: { getSKU } } = apiUrls;

export const SKU_SUCCESS = 'SKU_SUCCESS';
export const SKU_LOADING = 'SKU_LOADING';

export const getSKUData = () => async (dispatch) => {
    try {
        const { url } = getSKU
        const requestData = {
            ...getSKU,
            url
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: SKU_SUCCESS,
            data,
        })

    } catch (e) {

        dispatch({
            type: SKU_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            }
        })
    }

}

export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: SKU_LOADING,
        isLoading
    });
}